import { LoyaltyApi } from "@jti/rest-api";

import { TAGS } from "../common/tags";
import type { LoyaltyApiBuilder } from "../loyaltyApi.types";

export type GetLoyaltyPointsEndpointArgs = { uuid: string; ciam_token?: string };
export type GetLoyaltyPointsEndpointResponse = {
  points: number;
  pending_points: number;
};

export const getLoyaltyPointsEndpoint = (builder: LoyaltyApiBuilder) => ({
  getLoyaltyPoints: builder.query<GetLoyaltyPointsEndpointResponse, GetLoyaltyPointsEndpointArgs>({
    queryFn: async ({ uuid, ciam_token }) => {
      const loyaltyApi = LoyaltyApi.init();
      const data = await loyaltyApi.getPoints(uuid, ciam_token ?? "");

      return {
        data: {
          points: data?.points ?? 0,
          pending_points: data?.pending_points ?? 0,
        },
      };
    },
    providesTags: [TAGS.LOYALTY_POINTS],
  }),
});
